<template>
  <article>
    <div ref="header">
      <div class="plarform-search">
        <a href="javascript:void(0);" class="search-icon" @click.stop="search"></a>
        <input v-model="mobile" type="text" class="search-number" placeholder="请输联系电话">
      </div>

      <div class="tab-service">
        <ul class="tab-service-detail">
          <li :class="{'on':this.status===4}" @click="onShiftTap(4)"><a href="javascript:void(0);">待审核</a></li>
          <li :class="{'on':this.status===5}" @click="onShiftTap(5)"><a href="javascript:void(0);">已审核通过</a></li>
          <li :class="{'on':this.status===''}" @click="onShiftTap('')"><a href="javascript:void(0);">全部</a></li>
        </ul>
      </div>
    </div>

    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-for="(item, index) in  allRecord" :key="index">
          <cell class="personal-info-detail" :title="'销售顾问：' + item.sales">
            <span slot="value" class="info">提交时间：  {{item.request_fail_at}}</span>
          </cell>
          <cell class="personal-info-detail">
            <p slot="after-title" class="info">客户编号：{{item.id}}</p>
            <p slot="after-title" class="info">姓名：{{item.customer_name}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
            <flexbox slot="after-title" class="flexbox">
              <flexbox-item :span="20/100" class="key">战败原因：</flexbox-item>
              <flexbox-item class="value" style="margin-left: 0px">{{item.fail_reason}}</flexbox-item>
            </flexbox>
          </cell>
          <cell v-if="item.status===4">
            <div slot="value" class="oparete-btn">
              <a class="btn-pass-no" @click.stop="notPass(item.id)">审核不通过</a>
              <a class="btn-pass" @click.stop="surePass(item.id)">审核通过</a>&nbsp;&nbsp;
            </div>
          </cell>
        </group>
        <p class="tip-text1">共{{totalCount}}条记录</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  Flexbox,
  FlexboxItem,
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../../common/auth'

export default {
  components: {
    Scroller,
    Flexbox,
    FlexboxItem,
    Cell,
    Group
  },
  data () {
    return {
      authArr: [authApi.saleManage.sale_potential_customer_manage, authApi.saleManage.sale_potential_customer_view_all],
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      mobile: '',
      allRecord: [],
      status: '',
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      scrollerHeight: ''
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.$store.state.promiseAuth.then(auth => {
      let permission = authApi.haveEveryAuth(this.authArr, auth.authList)
      if (permission) {
        this.getData()
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    getData () {
      this.page = 1
      this.totalPage = 1
      this.allRecord = []
      this.$rest.saleManage.getFailAndPending({
        status: this.status,
        page: this.page,
        mobile: this.mobile,
        item_per_page: this.item_per_page
      }).then(res => {
        if (res.code === 0) {
          this.allRecord = res.data.customers
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        }
      })
    },
    notPass (id) {
      if (id) {
        this.$rest.saleManage.examineNotPass(null, id).then(res => {
          if (res.code === 0) {
            this.getData()
          } else {
            this.showToast(res.message)
          }
        })
      }
    },
    surePass (id) {
      if (id) {
        this.$rest.saleManage.examinePass(null, id).then(res => {
          if (res.code === 0) {
            this.getData()
          } else {
            this.showToast(res.message)
          }
        })
      }
    },
    search () {
      if (this.mobile) {
        this.getData()
      }
    },
    onShiftTap (status) {
      if (status === this.status) return false
      this.status = status
      this.getData()
    },
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.getFailAndPending({
          status: this.status,
          page: this.page,
          item_per_page: this.item_per_page
        }).then(res => {
          if (res.code === 0) {
            this.allRecord.push(...res.data.customers)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
